import { variant } from 'styled-system';

const buttonStyle = variant({
  key: 'buttonStyles',
});

const colorStyle = variant({
  key: 'colorStyles',
  prop: 'colors',
});

const sizeStyle = variant({
  key: 'sizeStyles',
  prop: 'size',
});

export const cards = variant({ key: 'cards' });

const variables = {
  borderRadius: '12.8px',
  borderRadius2: '4px',
};

export { buttonStyle, colorStyle, sizeStyle, variables };
